/* Cart drawer extras — keeps the free-shipping bar and the checkout-button
   total in sync after AJAX cart changes.

   This theme rebuilds the drawer with CartJS (client side) rather than
   re-rendering the Liquid section, so it rewrites `.totals__subtotal-value`
   on every cart change. We observe that element and recompute our custom
   bits from the authoritative CartJS cart total. */
(function () {
  function formatMoney(cents, format) {
    if (window.CartJS && CartJS.Utils && typeof CartJS.Utils.formatMoney === 'function') {
      return CartJS.Utils.formatMoney(cents, format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function () {
    var subtotalEl = document.querySelector('.totals__subtotal-value');
    var bar = document.querySelector('[data-ship-bar]');
    var btnTotal = document.querySelector('[data-checkout-total]');

    if (!subtotalEl) return;

    var moneyFormat =
      (bar && bar.getAttribute('data-money-format')) ||
      (btnTotal && btnTotal.getAttribute('data-money-format')) ||
      '${{amount}}';

    function currentTotalCents() {
      if (window.CartJS && CartJS.cart && typeof CartJS.cart.total_price === 'number') {
        return CartJS.cart.total_price;
      }
      // Fallback: parse the subtotal text the theme just wrote.
      var digits = (subtotalEl.textContent || '').replace(/[^0-9.]/g, '');
      return Math.round(parseFloat(digits || '0') * 100);
    }

    function updateBar(total) {
      if (!bar) return;
      // The bar is server-rendered even for an empty cart (hidden), because
      // CartJS rebuilds the drawer client-side and we can only update markup
      // that already exists. Toggle it the same way the drawer toggles its
      // empty state.
      var count =
        window.CartJS && CartJS.cart && typeof CartJS.cart.item_count === 'number'
          ? CartJS.cart.item_count
          : total > 0
            ? 1
            : 0;
      bar.style.display = count > 0 ? '' : 'none';
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 0;
      var remaining = Math.max(0, threshold - total);
      var unlocked = remaining <= 0;
      var pct = threshold > 0 ? Math.min(100, (total / threshold) * 100) : 0;

      bar.classList.toggle('is-unlocked', unlocked);

      var textEl = bar.querySelector('[data-ship-text]');
      if (textEl) {
        if (unlocked) {
          textEl.textContent = bar.getAttribute('data-msg-unlocked') || '';
        } else {
          var tmpl = bar.getAttribute('data-msg-progress') || '';
          textEl.innerHTML = tmpl.replace(
            '[amount]',
            '<span class="ship-amt">' + formatMoney(remaining, moneyFormat) + '</span>'
          );
        }
      }

      if (bar.getAttribute('data-track') === 'segmented') {
        var cells = bar.querySelectorAll('[data-ship-cell]');
        var n = cells.length || 1;
        cells.forEach(function (cell, i) {
          var lo = (i / n) * 100;
          var hi = ((i + 1) / n) * 100;
          var cw = Math.max(0, Math.min(100, ((pct - lo) / (hi - lo)) * 100));
          var fill = cell.querySelector('[data-ship-fill]');
          if (fill) fill.style.width = cw + '%';
        });
      } else {
        var fill = bar.querySelector('[data-ship-fill]');
        if (fill) fill.style.width = pct + '%';
      }
    }

    function updateButton(total) {
      if (btnTotal) btnTotal.textContent = formatMoney(total, moneyFormat);
    }

    // CartJS rewrites the subtotal as plain "$89.00 AUD"; re-wrap the trailing
    // currency code so it renders small/subtle like the design. The guard makes
    // this idempotent so it doesn't loop with the observer.
    function styleSubtotalCurrency() {
      if (!subtotalEl || subtotalEl.querySelector('.cart-subtotal-cur')) return;
      var txt = (subtotalEl.textContent || '').trim();
      var m = txt.match(/^(.*\d)\s+([A-Za-z]{2,4})\s*$/);
      if (m) {
        subtotalEl.innerHTML = m[1] + '<small class="cart-subtotal-cur">' + m[2] + '</small>';
      }
    }

    function updateAll() {
      styleSubtotalCurrency();
      var total = currentTotalCents();
      updateBar(total);
      updateButton(total);
    }

    var observer = new MutationObserver(updateAll);
    observer.observe(subtotalEl, { childList: true, characterData: true, subtree: true });

    // Belt-and-braces: also refresh when CartJS reports a completed request.
    if (window.jQuery) {
      window.jQuery(document).on('cart.requestComplete', updateAll);
    }
  });
})();
